module.exports = __webpack_public_path__ + "static/img/roman-kraft-_Zua2hyvTBk-unsplash_thumb.92f67c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/roman-kraft-_Zua2hyvTBk-unsplash_thumb.png
// module id = SADF
// module chunks = 4